import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { format } from "date-fns"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDateDisplay(value: string | undefined | null): string {
  if (!value || !value.trim()) return "-";
  const parsed = new Date(value);
  if (isNaN(parsed.getTime()) || parsed.getFullYear() < 1900) return "-";
  return format(parsed, "MMM dd, yyyy");
}
